import { IconType } from 'react-icons';
import { MdCheck, MdClose, MdDownloading } from 'react-icons/md';

import { type FileStatus } from './interfaces';

type DownloadStatusProps = {
  status: FileStatus;
};

const fileStatusIcons: Record<FileStatus, IconType> = {
  downloading: MdDownloading,
  downloaded: MdCheck,
  error: MdClose,
};

const fileStatusColors: Record<FileStatus, string> = {
  downloading: 'transparent',
  downloaded: '#349F23',
  error: '#B81C1D',
};

const DownloadStatus: React.FC<DownloadStatusProps> = ({ status }) => {
  const StatusIcon = fileStatusIcons[status];
  const statusColor = fileStatusColors[status];

  return (
    <div className="download-item-status" style={{ backgroundColor: statusColor }}>
      <StatusIcon size={16} />
    </div>
  );
};

export default DownloadStatus;
